/**
 * src/shell/save/seed.ts — 首启初始化（设计稿 §2 Phase 0）。
 *
 * 种子 = 仓库 data/*.json 原样（设计资产零改动纪律）：镇店存档——
 * 公司在职 3 人（白绍棠/周砚/墨守成）+ 镇店游戏《啤酒大战杆子》(proj_msckatc8)。
 * decisions 在 data/ 无对应文件，种子为空 wrapper（wrapper 结构纪律）；
 * reviews 自 deck v1.2 起有种子档案（B3 示例项目历史评审，rev_proj_msckatc8）。
 * 种子经 Vite 模块图打包（JSON import），data/ 仍是数值与存档唯一家，零复制。
 */

import type { Employee, SaveBundle } from '../../gm'
import employeesSeed from '../../../../data/employees.json'
import candidatesSeed from '../../../../data/candidates.json'
import marketSeed from '../../../../data/market.json'
import projectsSeed from '../../../../data/projects.json'
import reviewsSeed from '../../../../data/reviews.json'
import saveSeed from '../../../../data/save.json'
import { BUNDLE_KEYS, CANDIDATES_KEY, INIT_KEY, bundleKey } from './keys'

export interface CandidatesFile {
  candidates: Employee[]
}

export function seedBundle(): SaveBundle {
  return {
    save: structuredClone(saveSeed) as SaveBundle['save'],
    projects: structuredClone(projectsSeed) as SaveBundle['projects'],
    decisions: { decisions: [] },
    reviews: structuredClone(reviewsSeed) as SaveBundle['reviews'],
    employees: structuredClone(employeesSeed) as SaveBundle['employees'],
    market: structuredClone(marketSeed) as SaveBundle['market'],
  }
}

export function seedCandidates(): CandidatesFile {
  return structuredClone(candidatesSeed) as CandidatesFile
}

/** 首启判定与种子写入（幂等）。返回是否本次执行了初始化。 */
export function ensureInitialized(): boolean {
  if (localStorage.getItem(INIT_KEY)) return false
  const bundle = seedBundle()
  for (const k of BUNDLE_KEYS) {
    localStorage.setItem(bundleKey(k), JSON.stringify(bundle[k]))
  }
  localStorage.setItem(CANDIDATES_KEY, JSON.stringify(seedCandidates()))
  localStorage.setItem(INIT_KEY, new Date().toISOString())
  return true
}

export function isInitialized(): boolean {
  return localStorage.getItem(INIT_KEY) !== null
}
